<template>
  <div class="app h-screen">
    <RouterView class="Simple" />
  </div>
</template>

<script>
export default {
  metaInfo: {
    bodyAttrs: {
      class: 'simple',
    },
  },
  name: 'SimpleLayout',
}
</script>

<style lang="scss">
.app {
  background-color: #f3f3f7;
}
</style>
